import _ from 'lodash';
import initialState from './comfortCreditsInitialState';
import actions from './comfortCreditsAction';
import mutations from './comfortCreditsMutation';

const getters = {
  ccMemberTableRecordCount: (state) => {
    const {
      ccTableOptions: {
        itemsPerPage,
        totalItems,
      },
    } = state;
    if (totalItems === 0) {
      return 0;
    }
    return Math.ceil(totalItems / itemsPerPage);
  },
  ccMemberTableData: (state) => {
    const {
      ccMembers,
    } = state;
    let tableData = [];
    if (ccMembers.length > 0) {
      tableData = ccMembers.map((cc) => {
        const obj = {};
        obj.name = `${cc.firstName || ''} ${cc.lastName || ''}`;
        obj.corporationName = `${cc.corporationName}`;
        obj.plan = cc.plan;
        obj.email = cc.email;
        obj.balance = cc.balance;
        obj.customerId = cc.customerId;
        obj.loyaltyName = cc.loyaltyName;
        obj.vouchers = cc.voucherBalance;
        obj.corpId = cc.corpId;
        return obj;
      });
    }

    return tableData;
  },
  voucherTableRecordCount: (state) => {
    const {
      vouchers,
      voucherTableOptions: {
        itemsPerPage,
      },
    } = state;
    if (vouchers.length === 0) {
      return 0;
    }
    return Math.ceil(vouchers.length / itemsPerPage);
  },
  voucherTableData: (state) => {
    const {
      vouchers,
      ccFilters,
    } = state;
    let allVouchers = _.cloneDeep(vouchers);
    allVouchers = allVouchers.map((vv) => {
      if (vv.description.toLowerCase().includes('voucher')) {
        vv.transactionType = 'Voucher';
      } else {
        vv.transactionType = 'Credit';
      }
      return vv;
    });

    let filtered = allVouchers;
    if (ccFilters.reward === 'Vouchers') {
      filtered = filtered.filter((vv) => vv.transactionType === 'Voucher');
    } else if (ccFilters.reward === 'Credits') {
      filtered = filtered.filter((vv) => vv.transactionType === 'Credit');
    }
    if (ccFilters.selectedCustomer.id > 0) {
      filtered = filtered.filter((vv) => vv.customerId === ccFilters.selectedCustomer.id);
    }
    filtered = filtered.sort((x, y) => (new Date(x.creationDate) < new Date(y.creationDate) ? 1 : -1));
    return filtered;
  },
};

const comfortCreditModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default comfortCreditModule;
